<template>
  <Dropdown :transfer-class-name="'selfMenu'" placement="right-start" transfer>
    <DropdownItem>
      <span style="padding-left:10px;">{{ item.menuName }}</span>
      <Icon type="ios-arrow-forward"></Icon>
    </DropdownItem>
    <DropdownMenu slot="list">
      <template v-for="(child, i) in item.children">
        <DropdownItem
          :key="'sub-p-menu-shrink-'+item.pathName+'-'+child.pathName+'-'+i"
          :name="child.pathName"
          v-if="child.children == undefined || child.children == null || child.children.length == 0"
        >
          <span style="padding-left:10px;">{{ child.menuName || item.menuName}}</span>
          <Badge :count="$store.getters.inboxCount" v-if="child.menuCode == 'inbox'"></Badge>
          <Badge
            :count="$store.getters.todoCount"
            v-if="child.menuCode == 'workflow.config.myaffairs.todo'"
          ></Badge>
          <Badge
            :count="$store.getters.announcementCount"
            v-if="child.menuCode == 'announcement.published'"
          ></Badge>
        </DropdownItem>
        <sub-side-menu-shrink
          :item="child"
          :key="'sub-menu-shrink-'+item.pathName+'-'+child.pathName+'-index'"
          v-else
        ></sub-side-menu-shrink>
      </template>
    </DropdownMenu>
  </Dropdown>
</template>
<script>
export default {
  name: 'subSideMenuShrink',
  props: {
    item: {
      type: Object,
      default: () => { }
    },
  },
  methods: {
    changeSubMenu (active) {
      this.$emit('on-change', active)
    },
  },
}
</script>